export default __webpack_public_path__ + "static/media/6b4d4830-9c7d-43d2-b5d3-c73f739561b9.5c7914a6.woff2";